// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"601":"7925f3ebeb989248","804":"f50f009c61cdcaaf"}[chunkId] + ".js";
};